export default class Rectangle {
  constructor({ id, cx = 0, cy = 0, width = 0, height = 0, angle = 0, fill = '#000' }) {
    if (typeof id !== 'number') {
      throw new Error('Rectangle constructor requires an id');
    }
    this.id = id;
    this.attributes = {
      cx, cy, width, height, angle, fill
    };
  }

  update(attrs) {
    // return new Rectangle(Object.assign({}, this, attrs));
    const newAttrs = Object.assign({id: this.id}, this.attributes, attrs);
    // return newAttrs;
    return new Rectangle(newAttrs);
  }

  render(ctx) {
    const { width, height, cx, cy, angle, fill } = this.attributes;
    ctx.save();
    ctx.beginPath();
    ctx.translate(cx, cy);
    ctx.rotate(angle * Math.PI / 180);
    ctx.fillStyle = fill;
    ctx.fillRect(-width / 2, - height / 2, width, height);
    ctx.restore();
  }

}

Rectangle.keys = ['cx','cy', 'width', 'height', 'angle', 'fill'];